<template>
  <div class="login-container fcc">
    <div class="login-box fcc-h">
      <div class="logo-area">
        <img src="../assets/logo.png" alt="Virbac Logo" class="logo">
        <!-- <h2>维克宠物医疗系统</h2> -->
      </div>
      <div class="qrcode-container">
        <div class="qrcode-box" ref="qrcodeBox">
          <!-- 小程序码将在此显示 -->
          <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="小程序码" class="qrcode-img">
          <div v-if="qrCodeLoading" class="loading-overlay fcc">
            二维码生成中...
          </div>
          <div v-if="qrCodeExpired" class="expired-overlay fcc">
            二维码已过期<br>请点击刷新
          </div>
          <!-- 登录成功提示 -->
          <div v-if="loginSuccess" class="success-overlay fcc">
            <div class="success-icon">✓</div>
            <div class="success-text">登录成功</div>
            <div class="success-subtext">正在进入系统...</div>
          </div>
        </div>
        <p class="scan-tip">请使用微信扫一扫，扫描小程序码登录</p>
        <div class="refresh-btn fcc" @click="refreshQrCode">
          <img src="../assets/refresh-one.png" alt="刷新" class="refresh-icon">
          <span>刷新二维码</span>
        </div>
      </div>
    </div>
    
    <!-- 全屏登录成功提示 -->
    <div v-if="loginSuccess" class="fullscreen-success">
      <div class="success-modal fcc-h">
        <div class="big-success-icon">✓</div>
        <h2>登录成功</h2>
        <p>欢迎使用耳炎互动演示工具</p>
        <div class="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getLoginResult,
  getMiniLoginQrCode
} from "@/api/api";

export default {
  name: 'LoginPage',
  data() {
    return {
      qrCodeTimer: null,
      qrCodeExpired: false,
      qrCodeLoading: false,
      qrCodeUrl: '',
      polling: null,
      loginUuid: '',
      loginSuccess: false // 控制登录成功提示的显示
    }
  },
  created() {
    // 在创建组件时生成登录标识
    this.loginUuid = this.generateUUID();
  },
  mounted() {
    this.generateQrCode();
    // 启动轮询检查登录状态
    this.startPolling();
  },
  beforeDestroy() {
    // 清除定时器
    if (this.qrCodeTimer) {
      clearTimeout(this.qrCodeTimer);
    }
    if (this.polling) {
      clearInterval(this.polling);
    }
  },
  methods: {
    generateUUID() {
      // 生成 32 位以内的短随机串（小程序码 scene 上限 32 字符，不含 '-'）
      return 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
        return (Math.random() * 16 | 0).toString(16);
      });
    },
    generateQrCode() {
      // 清除过期状态
      this.qrCodeExpired = false;
      this.loginSuccess = false;
      this.qrCodeLoading = true;
      this.qrCodeUrl = '';

      // 重新生成 loginUuid
      this.loginUuid = this.generateUUID();

      // 调后端生成小程序码
      getMiniLoginQrCode({ uniLoginId: this.loginUuid }).then(res => {
        this.qrCodeLoading = false;
        if (res && res.data && res.data.qrCode) {
          this.qrCodeUrl = res.data.qrCode;
          // 设置二维码过期时间（2分钟后）
          this.qrCodeTimer = setTimeout(() => {
            this.qrCodeExpired = true;
          }, 120000);
        } else {
          this.qrCodeExpired = true;
          console.error('小程序码生成失败', res);
        }
      }).catch(error => {
        this.qrCodeLoading = false;
        this.qrCodeExpired = true;
        console.error('小程序码生成异常', error);
      });
    },
    refreshQrCode() {
      // 清除过期状态和定时器
      if (this.qrCodeTimer) {
        clearTimeout(this.qrCodeTimer);
      }

      // 重新生成二维码
      this.generateQrCode();
    },
    startPolling() {
      // 每3秒检查一次登录状态
      this.polling = setInterval(() => {
        this.checkLoginStatus();
      }, 3000);
    },
    checkLoginStatus() {
      if (!this.loginUuid) {
        console.error('Login UUID is not set');
        return;
      }
      let self = this
      getLoginResult({ uniLoginId: this.loginUuid }).then(res => {
        if (res.data && res.data.userInfo) {
          // 使用改进的登录方法，设置token和过期时间
          // 假设服务器返回了过期时间，如果没有则使用默认值（1天）
          const expiresIn = res.data.expiresIn || 86400; // 默认为1天
          self.login(res.data.token, expiresIn);
          
          console.log('Login successful');
          clearInterval(this.polling);
          self.polling = null;
          
          // 显示登录成功提示
          self.loginSuccess = true;
          
          // 3秒后跳转到首页
          setTimeout(() => {
            self.$router.push('/index');
          }, 3000);
        } else {
          console.log('Login failed');
        }
      }).catch(error => {
        console.error('Error fetching login result:', error);
      });
    }
  }
}
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4edf6 100%);
  position: relative;
}

.login-box {
  width: 400px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  padding: 40px;
  z-index: 1;
}

.logo-area {
  margin-bottom: 30px;
  text-align: center;
}

.logo {
  width: 120px;
  margin-bottom: 16px;
}

.logo-area h2 {
  font-size: 22px;
  color: #0063a5;
  margin: 0;
  font-weight: 500;
}

.qrcode-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode-box {
  width: 200px;
  height: 200px;
  background: #f9f9f9;
  border-radius: 8px;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.qrcode-img {
  max-width: 100%;
  max-height: 100%;
}

.scan-tip {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.refresh-btn {
  cursor: pointer;
  color: #0063a5;
  font-size: 14px;
}

.refresh-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}

.expired-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  color: #ff4d4f;
  font-size: 16px;
  text-align: center;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  color: #666;
  font-size: 14px;
  text-align: center;
}

.success-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.success-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #52c41a;
  color: white;
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.success-text {
  color: #52c41a;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 6px;
}

.success-subtext {
  color: #666;
  font-size: 14px;
}

/* 全屏登录成功提示 */
.fullscreen-success {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.success-modal {
  width: 320px;
  padding: 40px 30px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  text-align: center;
}

.big-success-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #52c41a;
  color: white;
  font-size: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  animation: zoomIn 0.5s ease-out;
}

@keyframes zoomIn {
  from { transform: scale(0); }
  to { transform: scale(1); }
}

.success-modal h2 {
  color: #52c41a;
  font-size: 24px;
  margin: 0 0 10px;
}

.success-modal p {
  color: #666;
  font-size: 16px;
  margin: 0 0 20px;
}

/* 加载动画 */
.loading-dots {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.loading-dots span {
  width: 8px;
  height: 8px;
  margin: 0 4px;
  background-color: #52c41a;
  border-radius: 50%;
  display: inline-block;
  animation: dot-flashing 1.4s infinite linear alternate;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dot-flashing {
  0% { opacity: 0.2; }
  100% { opacity: 1; }
}
</style>